var _rect, _path, _rect2, _path2, _path3, _path4;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconpdf = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#FBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.414 6H10C8.897 6 8 6.898 8 8V24C8 25.103 8.897 26 10 26H22C23.103 26 24 25.103 24 24V10.586L19.414 6ZM11 16H19V18H11V16ZM21 22H11V20H21V22ZM18 12V7L23 12H18Z",
    fill: "#C90000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 15,
    width: 12,
    height: 8,
    fill: "#C90000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4163 21.9996V18.3633H12.8509C13.1267 18.3633 13.3617 18.416 13.5558 18.5213C13.7499 18.6255 13.8979 18.7705 13.9997 18.9563C14.1027 19.141 14.1542 19.354 14.1542 19.5955C14.1542 19.837 14.1021 20.0501 13.9979 20.2347C13.8938 20.4194 13.7428 20.5632 13.5452 20.6662C13.3487 20.7692 13.1107 20.8207 12.8314 20.8207H11.917V20.2045H12.7071C12.8551 20.2045 12.977 20.1791 13.0729 20.1282C13.1699 20.0761 13.2421 20.0045 13.2895 19.9134C13.338 19.821 13.3623 19.7151 13.3623 19.5955C13.3623 19.4748 13.338 19.3694 13.2895 19.2795C13.2421 19.1883 13.1699 19.1179 13.0729 19.0682C12.9758 19.0173 12.8527 18.9918 12.7035 18.9918H12.1851V21.9996H11.4163Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9426 21.9996H14.6536V18.3633H15.9533C16.319 18.3633 16.6339 18.4361 16.8979 18.5817C17.1619 18.7261 17.3649 18.9338 17.5069 19.2049C17.6501 19.476 17.7217 19.8003 17.7217 20.1779C17.7217 20.5567 17.6501 20.8822 17.5069 21.1545C17.3649 21.4267 17.1607 21.6357 16.8943 21.7812C16.6292 21.9268 16.3119 21.9996 15.9426 21.9996ZM15.4224 21.3409H15.9107C16.1379 21.3409 16.3291 21.3007 16.4842 21.2202C16.6404 21.1385 16.7576 21.0124 16.8357 20.842C16.915 20.6703 16.9547 20.449 16.9547 20.1779C16.9547 19.9092 16.915 19.6896 16.8357 19.5192C16.7576 19.3487 16.641 19.2232 16.486 19.1428C16.3309 19.0623 16.1397 19.022 15.9124 19.022H15.4224V21.3409Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2913 21.9996V18.3633H20.6989V18.9972H19.0601V19.8636H20.5391V20.4975H19.0601V21.9996H18.2913Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconpdf, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/iconpdf.667feef2.svg";
export { ForwardRef as ReactComponent };